module.exports = __webpack_public_path__ + "img/bot-avatar.c97abacd.png";